import {
  Button,
  Container,
  Grid,
  Typography,
} from '@mui/material';

import Layout from 'lib/components/Layout';
import { logAnalyticsEvent } from 'lib/firebase/analytics';

import { base } from 'themes';
import { Logo } from 'components/icons';
import { FOOTER_PROPS } from 'constants';

import { useData } from 'hooks';

import SetSlot from './SetSlot';

export default function SetProgressPage() {
  const [data] = useData(`tcgist/sets`, []);

  return (
    <Layout
      theme={base}
      footerProps={FOOTER_PROPS}
      navbarProps={{
        logo: (<Logo />),
        right: (
          <Button
            href="https://szk4u.mjt.lu/wgt/szk4u/xu59/form?c=0799e44b"
            target="_blank"
            variant="contained"
            onClick={() => logAnalyticsEvent('click', { label: 'Try TCGist' })}
          >
            Try TCGist
          </Button>
        )
      }}
    >
      <Container sx={{ pt: 15 }}>
        <Typography variant="h4">
          Sets
        </Typography>
        <Grid container spacing={4} py={3}>
            {
              data && Object.keys(data).map((setCode) => {
                const set = data[setCode];

                return (
                  <Grid item xs={12} sm={6} md={4} key={setCode}>
                    <SetSlot
                      collection={set}
                      setCode={setCode}
                    />
                  </Grid>
                );
              })
            }
          </Grid>
      </Container>
    </Layout>
  );
};
